import EncryptedStorage from 'react-native-encrypted-storage';
import { Platform } from 'react-native';

const KEY = 'vr_chat_unread_counts_v1';

function isWeb(): boolean {
  return Platform.OS === 'web';
}

function normalizeUnreadCounts(raw: unknown): Record<string, number> {
  if (!raw || typeof raw !== 'object') return {};
  const out: Record<string, number> = {};
  for (const [chatId, value] of Object.entries(raw as Record<string, unknown>)) {
    if (!chatId) continue;
    const n = typeof value === 'number' ? value : Number(value);
    if (Number.isFinite(n) && n > 0) {
      out[chatId] = Math.floor(n);
    }
  }
  return out;
}

export async function readChatUnreadCounts(): Promise<Record<string, number>> {
  try {
    let raw: string | null = null;
    if (isWeb()) {
      raw = globalThis.localStorage?.getItem(KEY) ?? null;
    } else {
      raw = await EncryptedStorage.getItem(KEY);
    }
    if (!raw) return {};
    return normalizeUnreadCounts(JSON.parse(raw));
  } catch {
    return {};
  }
}

export async function writeChatUnreadCounts(value: Record<string, number>): Promise<void> {
  const normalized = normalizeUnreadCounts(value);
  const payload = JSON.stringify(normalized);
  try {
    if (isWeb()) {
      globalThis.localStorage?.setItem(KEY, payload);
      return;
    }
    await EncryptedStorage.setItem(KEY, payload);
  } catch {
    /* ignore storage write errors */
  }
}
